import React from 'react';
import Icon from 'components/AppIcon';
import { useNotifications } from '../../contexts/NotificationContext';

export default function NotificationBell() {
  const { unreadCount, togglePanel, isOpen } = useNotifications();

  return (
    <button
      onClick={togglePanel}
      aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread` : ''}`}
      className={`relative flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00E5FF] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D1B2A] ${
        isOpen
          ? 'bg-[rgba(0,229,255,0.15)] text-[#00E5FF]'
          : 'text-[#94A3B8] hover:text-[#E2E8F0] hover:bg-[rgba(0,229,255,0.06)]'
      }`}
    >
      <Icon name="Bell" size={20} color="currentColor" strokeWidth={isOpen ? 2.5 : 2} />
      {unreadCount > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center rounded-full text-[10px] font-bold leading-none px-1 bg-[#00E5FF] text-[#0D1B2A] shadow-[0_0_8px_rgba(0,229,255,0.6)]"
          aria-hidden="true"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
